import React, { createContext, useState } from 'react';

export interface ISelectedPlan {
  miles: string;
}

export interface ISelectedPlansContext {
  selectedPlans: ISelectedPlan[];
  setSelectedPlans: (planList: ISelectedPlan[]) => void;
  clearPlans: () => void;
}

const SelectedPlansContext = createContext<ISelectedPlansContext>({} as ISelectedPlansContext);

function SelectedPlansProvider({ children }: any) {
  const [selectedPlans, setSelectedPlans] = useState<ISelectedPlan[]>([]);

  const clearPlans = () => {
    setSelectedPlans([]);
  };

  return (
    <SelectedPlansContext.Provider
      value={{
        selectedPlans,
        setSelectedPlans,
        clearPlans,
      }}
    >
      {children}
    </SelectedPlansContext.Provider>
  );
}

const useSelectedPlans = () => {
  const context = React.useContext(SelectedPlansContext);
  return context;
};

export { useSelectedPlans };

export default SelectedPlansProvider;
